<div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">

  <div class="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4">
    <span class="text-surface-500 dark:text-surface-400 text-sm">
      Podsumowanie:
    </span>
    <span class="text-surface-900 dark:text-surface-0 font-semibold text-xl sm:text-2xl">
      {{ totals().totalTime | minutesToHours: 'long' }}
    </span>
  </div>

  <div class="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4">
    <span class="text-surface-500 dark:text-surface-400 text-sm">
      Łączne wynagrodzenie:
    </span>
    <span class="text-surface-900 dark:text-surface-0 font-semibold text-xl sm:text-2xl">
      {{ totals().totalAmount | currency: 'PLN':'symbol':'1.2-2':'pl-PL' }}
    </span>
  </div>

</div>
